import React from 'react';
import { ThumbnailView } from './ThumbnailView';
import { Pose, CameraState } from '../types';

interface PosePreviewBoxProps {
  pose?: Pose;
  cameraState?: CameraState;
  className?: string;
  style?: React.CSSProperties;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onMouseDown?: (e: React.MouseEvent) => void;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

/**
 * Hover-preview popup shell (mannequin pane left, notes pane right) shared by
 * the Pose Library's Pose Preview popup and the Timeline's keyframe hover
 * preview, per docs/requirements/PosesLibrary.md "Pose Preview Control".
 */
export function PosePreviewBox({ pose, cameraState, className, style, onMouseEnter, onMouseLeave, onMouseDown, onClick, children }: PosePreviewBoxProps) {
  return (
    <div
      className={`pose-preview-popup${className ? ` ${className}` : ''}`}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onClick={onClick}
    >
      <div className="pose-preview-popup-mannequin">
        {pose && <ThumbnailView pose={pose} cameraState={cameraState} scaleFactor={1.5} />}
      </div>
      <div className="pose-preview-popup-notes">
        {children}
      </div>
    </div>
  );
}
